// extracted by mini-css-extract-plugin
module.exports = {"container":"AllCountries_container__UWvkL"};